var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('history',{attrs:{"title":"Historia","show-more":false}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }